"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneIcon = exports.VideoIcon = exports.VisitContent = exports.VisitHeading = exports.ApptTimeLeftContainer = exports.MapContent = exports.MapContainer = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const breakpoints_1 = require("../../lib/constants/breakpoints");
exports.Container = (0, styled_1.default)('div') `
  display: flex;

  flex-direction: column;
  align-items: center;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    flex-direction: row;
    align-items: inherit;
  }

  .filter_toolbar__container {
    @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
      padding-top: 0rem;
      top: ${(props) => props.headerHeight + 'px'};
    }
  }
`;
exports.MapContainer = (0, styled_1.default)('div') `
  width: 100%;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    width: auto;
  }
`;
exports.MapContent = (0, styled_1.default)('div') `
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    max-width: ${breakpoints_1.SIDEBAR_WIDTH};
    position: sticky;
    top: ${(props) => props.headerHeight + 'px'};
  }

  background: #fff;
`;
exports.ApptTimeLeftContainer = (0, styled_1.default)('div') `
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    width: ${breakpoints_1.SIDEBAR_WIDTH};
    min-height: ${breakpoints_1.VISIT_TYPE_CONTENT_HEIGHT};
    top: ${(props) => props.headerHeight + 'px'};
    position: sticky;
    border: 1px solid;
    border-color: ${(0, ui_theme_1.fromTheme)('color_border')};
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }

  background: #fff;
`;
exports.VisitHeading = (0, styled_1.default)('h5') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin: 0;
  display: flex;
`;
exports.VisitContent = (0, styled_1.default)('p') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.VideoIcon = (0, styled_1.default)('span') `
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  margin-left: -${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  height: 22px;
`;
exports.PhoneIcon = (0, styled_1.default)('span') `
  margin-right: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
`;
//# sourceMappingURL=styles.js.map